import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';
import { DropdownItemSwitch } from 'approot/shared/dropdown/dropdown-item.style';
import { SwitchStyled } from 'approot/shared/switch/switch.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { SettingsGroup } from 'approot/activity-builder/settings/settings.style';

export const ComponentSettings = styled.div`
  display: flex;
  height: ${rem(32)};
`;

export const ComponentDropdownButton = styled(DropdownToggle)`
  border: none;
  height: ${rem(32)};
  white-space: nowrap;
`;

export const ComponentDropdownSwitch = styled(DropdownItemSwitch)`
  justify-content: space-between;
  padding-left: ${rem(spacing4)};
  padding-right: ${rem(spacing4)};

  ${SwitchStyled} {
    min-width: ${rem(48)};
  }
`;

export const ComponentSettingsGroup = styled(SettingsGroup)`
  padding-left: ${rem(spacing4)};
  padding-right: ${rem(spacing4)};
`;
